import { Button } from "@/components/core/buttons/button";
import { Form } from "@/components/core/forms/form.tsx";
import {
	FormField,
	FormGroup,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/core/forms/form.tsx";
import { Input } from "@/components/core/forms/input";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { queryClient } from "@/query-client";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useCourtBranchMutation } from "../api/queries/court-branches-query";

import {
	type CourtBranch,
	type CourtBranchForm,
	courtBranchFormSchema,
} from "../types/court-branches";

export default function CourtBranchmodal({ data }: { data: CourtBranch }) {
	const { closeModal } = useModalControl();
	const courtBranchMutation = useCourtBranchMutation(data?.id);

	const form = useForm<CourtBranchForm>({
		resolver: zodResolver(courtBranchFormSchema),
		defaultValues: {
			id: data?.id,
			court_station_id: data?.court_station_id,
			judge: data?.judge,
			name: data?.name,
			address: data?.address,
		},
	});

	const handleSubmit = async (values: CourtBranchForm) => {
		try {
			await courtBranchMutation.mutateAsync(values);
			await queryClient.invalidateQueries({ queryKey: ["court_branches"] });
			closeModal();
		} catch (error) {}
	};

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(handleSubmit)}>
				<div className="grid grid-cols-12 w-full gap-3 py-3">
					<div className="col-span-12 w-full">
						<FormField
							control={form.control}
							name="name"
							render={({ field }) => (
								<FormItem>
									<div className="flex flex-col w-full">
										<FormLabel required>Name</FormLabel>
									</div>
									<FormGroup iconPosition="left">
										<Input
											autoComplete="off"
											placeholder="Name"
											disabled
											{...field}
										/>
									</FormGroup>
									<FormMessage />
								</FormItem>
							)}
						/>
					</div>
					<div className="col-span-12 w-full">
						<FormField
							control={form.control}
							name="judge"
							render={({ field }) => (
								<FormItem>
									<div className="flex flex-col w-full">
										<FormLabel required>Presiding Judge</FormLabel>
									</div>
									<FormGroup iconPosition="left">
										<Input autoComplete="off" placeholder="Judge" {...field} />
									</FormGroup>
									<FormMessage />
								</FormItem>
							)}
						/>
					</div>
					<div className="col-span-12 w-full">
						<FormField
							control={form.control}
							name="address"
							render={({ field }) => (
								<FormItem>
									<div className="flex flex-col w-full">
										<FormLabel required>Address</FormLabel>
									</div>
									<FormGroup iconPosition="left">
										<Input
											autoComplete="off"
											placeholder="Address"
											{...field}
										/>
									</FormGroup>
									<FormMessage />
								</FormItem>
							)}
						/>
					</div>
				</div>
				<div className="flex flex-row justify-between w-full gap-4 mt-2">
					<Button
						className=""
						variant="ghost"
						type="button"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>
					<Button className="" variant="default">
						Confirm
					</Button>
				</div>
			</form>
		</Form>
	);
}
